var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TablePaginated',{attrs:{"label":"Language","sublabel":"What languages are used by your passengers?","main-list":_vm.itemData,"is-global-percent":_vm.isGlobalPercent}})
}
var staticRenderFns = []

export { render, staticRenderFns }